import { routeTracker } from './routeTracker';

routeTracker._initializeTracker();
